var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_1",
    "data-name": "Component 9 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 13,
    height: 17,
    fill: "#808080"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M12.4,3.552l-.6-.6L10.061,1.2l-.6-.6-.6-.6H5.017A1.98,1.98,0,0,0,3.041,1.984V3H1.975A1.98,1.98,0,0,0,0,4.984V15.016A1.98,1.98,0,0,0,1.975,17H7.984a1.979,1.979,0,0,0,1.975-1.984V14h1.066A1.979,1.979,0,0,0,13,12.016V4.152Zm-.6,8.464a.783.783,0,0,1-.78.784H5.017a.783.783,0,0,1-.781-.784V1.984A.782.782,0,0,1,5.017,1.2H7.423V5.6h4.382ZM9.862,4.4H8.618V1.449L11.558,4.4Zm-1.1,10.616a.783.783,0,0,1-.78.785H1.975a.783.783,0,0,1-.78-.785V4.984a.782.782,0,0,1,.78-.783H3.041v7.815A1.98,1.98,0,0,0,5.017,14H8.764Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconDisabled);
export default __webpack_public_path__ + "static/media/copyIconDisabled.8de42f82886491471ef7754349e05774.svg";
export { ForwardRef as ReactComponent };